import { z } from "zod";
/**
 * Public contact form (landing page, bitebalance.de/#contact) — the Impressum's
 * second direct contact channel (§5 DDG) besides email. No account, no JWT:
 * anyone can send. The server forwards each message by email to hello@ via SES
 * and answers with a receipt id the page shows as its on-page confirmation.
 *
 * Spam protection without a CAPTCHA: `website` is a honeypot (hidden from
 * people, filled by naive bots) and `elapsedMs` is how long the form was open
 * before sending. A filled honeypot or an implausibly fast submit is answered
 * exactly like a real one but never forwarded, so a bot learns nothing. The
 * route is additionally rate-limited at the API gateway.
 */
export const CONTACT_TOPICS = ["general", "account", "employer", "partnership", "other"];
export const ContactTopicSchema = z.enum(CONTACT_TOPICS);
/** Header-bound fields must never carry line breaks (they end up in an email's Reply-To/Subject). */
const singleLine = (max) => z
    .string()
    .trim()
    .min(1)
    .max(max)
    .refine(value => !/[\r\n]/.test(value), "must be a single line");
export const ContactRequestSchema = z.object({
    firstName: singleLine(100),
    lastName: singleLine(100),
    email: z.string().trim().max(254).email().refine(value => !/[\r\n]/.test(value), "must be a single line"),
    topic: ContactTopicSchema,
    message: z.string().trim().min(1).max(5000),
    locale: z.enum(["de", "en"]),
    /** Honeypot: hidden from people; any value means a bot. */
    website: z.string().max(500).optional(),
    /** Milliseconds the form was open before sending (client-measured, spam signal only). */
    elapsedMs: z.number().int().nonnegative().optional(),
});
export const ContactResponseSchema = z.object({
    status: z.literal("received"),
    /** Shown on the page so the visitor can quote it; also the key of the server-side receipt log. */
    receiptId: z.string(),
});
//# sourceMappingURL=contact.js.map